module.exports = __webpack_public_path__ + "img/qiyabiaozuo.prt.92f5dd24.jpg";